import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { createAxiosInstance } from "../axiosSettings";
import { logout } from "./authSlice";

const initialState = {
  isLoading: false,
  userList : [],
  providersList : [],
  userDetail : null,
  userData : null,
  dashboardData : null,
  error : null
};


export const PROVIDER_LIST = "admin/providers";
export const USER_DETAIL = "admin/user";
export const USER_LIST = "admin/users";
export const USER_UPDATE = "admin/user";
export const DASHBOARD_URL = "admin/dashboard";

export const getProvidersList = createAsyncThunk(
  PROVIDER_LIST,
  async (formData, { rejectWithValue }) => {
    const axiosInstance = await createAxiosInstance();
    try {
      const response = await axiosInstance.get(PROVIDER_LIST, {
        params : formData
      });
      if (response.data) {
        return response.data;
      } else {
        return rejectWithValue(response.data.message || "Error");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error"
      );
    }
  }
);

export const getUserDetail = createAsyncThunk(
  USER_DETAIL,
  async (id, { rejectWithValue }) => {
    const axiosInstance = await createAxiosInstance();
    try {
      const response = await axiosInstance.get(USER_DETAIL + '/' + id);
      if (response.data) {
        return response.data;
      } else {
        return rejectWithValue(response.data.message || "Error");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error"
      );
    }
  }
);

export const getUsersList = createAsyncThunk(
  USER_LIST,
  async (formData, { rejectWithValue }) => {
    const axiosInstance = await createAxiosInstance();
    try {
      const response = await axiosInstance.get(USER_LIST, {
        params : formData
      });
      if (response.data) {
        return response.data;
      } else {
        return rejectWithValue(response.data.message || "Error");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error"
      );
    }
  }
);

export const getDashboardData = createAsyncThunk(
  DASHBOARD_URL,
  async (formData, { rejectWithValue }) => {
    const axiosInstance = await createAxiosInstance();
    try {
      const response = await axiosInstance.get(DASHBOARD_URL);
      if (response.data) {
        return response.data;
      } else {
        return rejectWithValue(response.data.message || "Error");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error"
      );
    }
  }
);

export const userStatusUpdate = createAsyncThunk(
  USER_UPDATE + "/status",
  async (formData, { rejectWithValue }) => {
    const axiosInstance = await createAxiosInstance();
    try {
      const response = await axiosInstance.post(USER_UPDATE, formData);
      if (response.data) {
        return response.data;
      } else {
        return rejectWithValue(response.data.message || "Error");
      }
    } catch (error) {
      console.log(error)
      return rejectWithValue(
        error.response?.data?.message || "Error"
      );
    }
  }
);

const adminSlice = createSlice({
  name: "admin",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getProvidersList.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getProvidersList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.providersList = action.payload;
      })
      .addCase(getProvidersList.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(getUserDetail.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getUserDetail.fulfilled, (state, action) => {
        state.isLoading = false;
        state.userDetail = action.payload;
      })
      .addCase(getUserDetail.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(getUsersList.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getUsersList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.userList = action.payload;
      })
      .addCase(getUsersList.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(userStatusUpdate.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(userStatusUpdate.fulfilled, (state, action) => {
        state.isLoading = false;
        state.userData = action.payload;
      })
      .addCase(userStatusUpdate.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(getDashboardData.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getDashboardData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.dashboardData = action.payload;
      })
      .addCase(getDashboardData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(logout, () => initialState);
  },
});

export default adminSlice.reducer;